export const WHATSAPP_NUMBER = "447539889920";

export const waLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    text || "Hello Upper Class Chauffeurs, I would like to make a booking."
  )}`;

export const NAV_LINKS = [
  { label: "Fleet", href: "#fleet" },
  { label: "Why Us", href: "#manifesto" },
  { label: "How It Works", href: "#process" },
  { label: "Reviews", href: "#testimonials" },
  { label: "Contact", href: "#contact" },
];

export const FLEET = [
  {
    id: "business",
    tier: "Business",
    model: "Mercedes-Benz E-Class",
    price: "99",
    seats: "3 Passengers",
    luggage: "2 Suitcases",
    blurb:
      "The definitive executive saloon. Refined, understated and impeccably comfortable for the daily commute or airport transfer.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/50440326-f793-45b3-85c9-b419cf332040/images/9dd3ec65195616a3b7d5a77c4bb08c8a522abd90903f0cdfe2616def21f3a7f4.jpeg",
  },
  {
    id: "first",
    tier: "First",
    model: "Mercedes-Benz S-Class",
    price: "149",
    seats: "3 Passengers",
    luggage: "2 Suitcases",
    blurb:
      "The all-new S-Class, just released. Illuminated grille, next-generation cabin serenity and the last word in first-class travel.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/50440326-f793-45b3-85c9-b419cf332040/images/ac502e3999a1bfbef2b3df174680979da1b530c8cb57628e9f9ae718e8c6ab31.jpeg",
    featured: true,
  },
  {
    id: "suv",
    tier: "SUV",
    model: "Range Rover Autobiography",
    price: "199",
    seats: "4 Passengers",
    luggage: "3 Suitcases",
    blurb:
      "Commanding presence with effortless composure. The Range Rover Autobiography pairs British luxury with a calm, elevated ride quality.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/50440326-f793-45b3-85c9-b419cf332040/images/cbb1bd075eebc079d6b95bb1c44c6ff56ed003cab34b0deceb7a693dd013b385.jpeg",
  },
  {
    id: "space",
    tier: "Space",
    model: "Mercedes-Benz VLE",
    price: "149",
    seats: "7 Passengers",
    luggage: "7 Suitcases",
    blurb:
      "Generous room for the whole party. Ideal for groups, families and larger luggage loads without compromising on luxury.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/50440326-f793-45b3-85c9-b419cf332040/images/ff92dd7659bbc98893f9d3b6d90b719b5375069611bbf3c8e333429ba636de5d.jpeg",
  },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Master Chauffeurs",
    body: "Every driver brings 10+ years of professional experience. Discreet, punctual and immaculately presented — the difference is felt from the first mile.",
  },
  {
    no: "02",
    title: "A Youthful Fleet",
    body: "No vehicle in our fleet is more than three years old. Each is meticulously maintained, valeted and prepared before every single journey.",
  },
  {
    no: "03",
    title: "Amenities, On The House",
    body: "Complimentary still water, tissues, on-board Wi-Fi and phone charging in every car. The small details that make a considered difference.",
  },
  {
    no: "04",
    title: "Safe & Reliable",
    body: "Fully licensed, insured and background-checked. Real-time flight tracking and 24/7 support mean you always arrive with total peace of mind.",
  },
];

export const PROCESS = [
  {
    no: "01",
    title: "Tell Us Your Journey",
    body: "Message us on WhatsApp or send an enquiry with your pick-up, destination and time.",
  },
  {
    no: "02",
    title: "Confirm Your Car",
    body: "We match you with the ideal vehicle and confirm a fixed, transparent price — from £99.",
  },
  {
    no: "03",
    title: "Sit Back & Arrive",
    body: "Your chauffeur arrives early, tracks your flight and delivers you in first-class comfort.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Flawless from booking to arrival. The new S-Class was immaculate and the driver was the epitome of professionalism.",
    name: "Eleanor V.",
    role: "Private Client, Mayfair",
  },
  {
    quote:
      "We use Upper Class for every airport run. Always early, always spotless, always discreet. Simply the best in London.",
    name: "James Whitmore",
    role: "Managing Director",
  },
  {
    quote:
      "The attention to detail is remarkable — chilled water, Wi-Fi, and a driver who genuinely knows the city. Faultless.",
    name: "Priya S.",
    role: "Frequent Traveller",
  },
];
